<template>
    <a-card :bordered="false">
      <a-form-item><a @click="routeBack">&lt;&lt; 返回</a></a-form-item>
      <detail-list title="称重详情" v-if="mdl">
        <detail-list-item term="物流单号">{{ mdl.logisticsNo }}</detail-list-item>
        <detail-list-item term="车号">{{ mdl.vehicleNo }}</detail-list-item>
        <detail-list-item term="卡号">{{ mdl.cardNo }}</detail-list-item>
        <detail-list-item term="物流状态">{{ getLogStatusTextByValue(bizCodeList, mdl.businessTypeId, mdl.logStatus)}}</detail-list-item>
        <detail-list-item term="称重单号">{{ mdl.weighingNo }}</detail-list-item>
        <detail-list-item term="创建时间">{{ mdl.createTime | formatDate}}</detail-list-item>
        <detail-list-item term="皮重">{{ mdl.tare }}</detail-list-item>
        <detail-list-item term="毛重">{{ mdl.gross }}</detail-list-item>
        <detail-list-item term="净重">{{ mdl.net }}</detail-list-item>
        <detail-list-item term="皮重时间">{{ mdl.tareTime | formatDate}}</detail-list-item>
        <detail-list-item term="毛重时间">{{ mdl.grossTime | formatDate}}</detail-list-item>
        <detail-list-item term="扣杂类型">{{ mdl.deductOneType }}</detail-list-item>
        <detail-list-item term="皮重操作人">{{ mdl.tareUsername }}</detail-list-item>
        <detail-list-item term="毛重操作人">{{ mdl.grossUsername }}</detail-list-item>
        <detail-list-item term="扣杂">{{ mdl.deductOne }}</detail-list-item>
        <detail-list-item term="皮重称台">{{ mdl.tareScale }}</detail-list-item>
        <detail-list-item term="毛重称台">{{ mdl.grossScale }}</detail-list-item>
        <detail-list-item term="扣杂类型2">{{ mdl.deductTwoType }}</detail-list-item>

        <detail-list-item term="皮重抓拍车牌">{{ mdl.tareLpr }}</detail-list-item>
        <detail-list-item term="毛重抓拍车牌">{{ mdl.grossLpr }}</detail-list-item>
        <detail-list-item term="扣杂2">{{ mdl.deductTwo }}</detail-list-item>
        <detail-list-item term="皮重数据来源">{{ mdl.tareFrom }}</detail-list-item>
        <detail-list-item term="毛重数据来源">{{ mdl.grossFrom }}</detail-list-item>
        <detail-list-item term="实重">{{ mdl.factOne }}</detail-list-item>
        <detail-list-item term="皮重数据采集说明">{{ mdl.tareExplain }}</detail-list-item>
        <detail-list-item term="毛重数据采集说明">{{ mdl.grossExplain }}</detail-list-item>

        <detail-list-item term="实重2">{{ mdl.factTwo }}</detail-list-item>
        <detail-list-item term="过磅次数">{{ mdl.weighCount }}</detail-list-item>
        <detail-list-item term="打印次数">{{ mdl.printCount }}</detail-list-item>
        <detail-list-item term="是否需要上传">{{ mdl.needUpload }}</detail-list-item>
        <detail-list-item term="件数">{{ mdl.pieceCount }}</detail-list-item>
        <detail-list-item term="重量-件数转换公式">{{ mdl.weighingToPiece }}</detail-list-item>
        <detail-list-item term="货物单价">{{ mdl.materielPrice }}</detail-list-item>
        <detail-list-item term="运费单价">{{ mdl.freightPrice }}</detail-list-item>
        <detail-list-item term="货物金额">{{ mdl.materielMoney }}</detail-list-item>
        <detail-list-item term="运费金额">{{ mdl.freightMoney }}</detail-list-item>
        <detail-list-item term="第一次过磅时间">{{ mdl.beginTime | formatDate}}</detail-list-item>
        <detail-list-item term="第二次过磅时间">{{ mdl.endTime | formatDate}}</detail-list-item>
        <detail-list-item term=""> </detail-list-item>
        <detail-list-item term="车牌对比描述(一次过磅)">{{ mdl.beginDesc }}</detail-list-item>
        <detail-list-item term="车牌对比描述(二次过磅)">{{ mdl.endDesc }}</detail-list-item>
        <detail-list-item term="备注">{{ mdl.remark }}</detail-list-item>
        <detail-list-item term="皮重图片">
    <!--         <span v-show="mdl.tareImg != null && mdl.tareImg != ''" style="margin-right:10px;" v-for ="item in mdl.tareImg.split(',')" :key="item">
                <img width="100"  onclick="window.open(this.src)" :src="imgApiUrl + item" :data-path="imgApiUrl+item" >
            </span> -->
            <vue-preview :slides="setTarePreview()" class="preview"></vue-preview>
        </detail-list-item>
        <detail-list-item term="毛重图片">
      <!--    <span v-show="mdl.grossImg != null && mdl.grossImg != ''" style="margin-right:10px;" v-for ="item in mdl.grossImg.split(',')" :key="item">
              <img width="100" onclick="window.open(this.src)" :src="imgApiUrl + item" >
            </span>  -->
            <vue-preview :slides="setGrossPreview()" class="preview"></vue-preview>
        </detail-list-item>

        <detail-list-item term="皮重抓拍车牌图片">
          <!--         <span v-show="mdl.tareLprImg != null && mdl.tareLprImg != ''" style="margin-right:10px;" v-for ="item in mdl.tareLprImg.split(',')" :key="item">
                      <img width="100"  onclick="window.open(this.src)" :src="imgApiUrl + item" :data-path="imgApiUrl+item" >
                  </span> -->
                 <vue-preview :slides="setTareLprPreview()" class="preview"></vue-preview> 
        </detail-list-item>
        <detail-list-item term="毛重抓拍车牌图片">
           <!--  <span v-show="mdl.grossLprImg != null && mdl.grossLprImg != ''" style="margin-right:10px;" v-for ="item in mdl.grossLprImg.split(',')" :key="item">
              <img width="100" :src="imgApiUrl + item" >
            </span> -->
           <!--预览-->
          <vue-preview :slides="setGrossLprPreview()" class="preview"></vue-preview>
        </detail-list-item>
      </detail-list>
    </a-card>
  </page-view>
</template>

<script>
import DetailList from '@/components/tools/DetailList'
import Moment from 'moment'
import { getNameByTypeAndValue, attachmentList, common,showImgById } from '@/api/sys'
import { getTextByTypeAndValue, getLogStatusTextByValue } from '@/utils/util'
import storage from "@/utils/storage"
 //引入子组件
 import '@/assets/css/global.css'

const DetailListItem = DetailList.Item

export default {
  components: {
    DetailList,
    DetailListItem,
  },
  data () {
    return {
      mdl: null,
      imgApiUrl: this.config.imgApiUrl, 
      codeList:[],
      bizCodeList:[],
      getLogStatusTextByValue:getLogStatusTextByValue

    }
  },
  //components:{vuePreview},
  mounted () {
    this.initData()
  },
  filters: {
    formatDate (value) {
      return Moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  methods: {
    routeBack(){
      localStorage.setItem('goback', "true");
      this.$router.back(-1)
    },
    setGrossPreview:function () {
      return this.setPreview(this.mdl.grossImg, "毛重图片", 1800, 1000)
    },
    setTarePreview:function () {
      return this.setPreview(this.mdl.tareImg, "皮重图片", 1800, 1000)
    },
    setGrossLprPreview:function () {
      return this.setPreview(this.mdl.grossLprImg, "毛重抓拍车牌", 200, 100)
    },
    setTareLprPreview:function () {
      return this.setPreview(this.mdl.tareLprImg, "皮重抓拍车牌", 200, 100)
    },
    setPreview (imgList, title, width,height){
      if (!imgList){
        return
      }
      imgList.forEach( img => {
        img.msrc = img.src;
        img.alt = title;
        img.title = title;
        img.w = width;
        img.h = height;
      })
      return imgList;
    },
    setImagePath(imgList){
      if (!imgList) return
      imgList = imgList.split(',').map(value => {
        return {
          // ...value,
          src: this.imgApiUrl + value
        }
      })
      return imgList
    },
    initData () {
      let weightCache = storage.fetch("cache-WeighingDetail");
      if (weightCache){
          this.mdl = JSON.parse(weightCache);
          this.mdl.tareImg = this.setImagePath(this.mdl.tareImg)
          this.mdl.grossImg = this.setImagePath(this.mdl.grossImg)
          this.mdl.grossLprImg = this.setImagePath(this.mdl.grossLprImg)
          this.mdl.tareLprImg = this.setImagePath(this.mdl.tareLprImg)
       } 
      // this.mdl = JSON.parse(this.$route.query.datas)
      this.getNameByTypeAndValue(this.config.TYPE_CODE.MATERIEL_TYPE,this.mdl.materielType, 'materielType' )
      this.getNameByTypeAndValue(this.config.TYPE_CODE.MATERIEL_STATUS,this.mdl.matStatus,'matStatus' )
      this.codeList = this.$store.getters.codeList
      this.bizCodeList = this.$store.getters.bizCodeList
      this.mdl.tareFrom = getTextByTypeAndValue(this.codeList,this.config.TYPE_CODE.LOGISTICS_WEIGHING_FROM, this.mdl.tareFrom )
      this.mdl.grossFrom = getTextByTypeAndValue(this.codeList,this.config.TYPE_CODE.LOGISTICS_WEIGHING_FROM, this.mdl.grossFrom )
      this.mdl.tareExplain = getTextByTypeAndValue(this.codeList,this.config.TYPE_CODE.LOGISTICS_WEIGHING_FROM, this.mdl.tareExplain )
      this.mdl.grossExplain = getTextByTypeAndValue(this.codeList,this.config.TYPE_CODE.LOGISTICS_WEIGHING_FROM, this.mdl.grossExplain )
    },

    getNameByTypeAndValue(type, value, column) { 
      new Promise(resolve => {
        const data = getNameByTypeAndValue({ "type":type, "value":value}).then(res => { 
          return res.data 
        })
        resolve(data)
      }).then(res => {
        this.mdl[column] = res
      })
    },

  }
}
</script>
